module.exports = __webpack_public_path__ + "img/dw4.c5e391aa.jpg";